import { z } from "zod";
import { FeedContentType, FeedSortOrder } from "../enum.js";

export const feedQuerySchema = z
	.object({
		cursor: z.string().optional(),
		limit: z.coerce.number().int().min(1).max(50).default(20),
		sort: z.enum(FeedSortOrder).default(FeedSortOrder.LATEST),
		content_type: z.enum(FeedContentType).default(FeedContentType.ALL),
		group_ids: z.string().optional(),
	})
	.strict();

export type FeedQueryPayload = z.infer<typeof feedQuerySchema>;
